import { render, staticRenderFns } from "./VirHomePart5.vue?vue&type=template&id=628442b4&scoped=true&"
import script from "./VirHomePart5.vue?vue&type=script&lang=js&"
export * from "./VirHomePart5.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart5.vue?vue&type=style&index=0&id=628442b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628442b4",
  null
  
)

export default component.exports